module.exports = __webpack_public_path__ + "img/sec-circle3.8dec591.png";